import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

import { environment } from '../../../../environments/environment';
import { AgricolaToastType } from '../../../interfaces/agricola.interface';

@Component({
  selector: 'app-agricola-login',
  templateUrl: './agricola-login.component.html',
  styleUrls: ['./agricola-login.component.css'],
  standalone: false
})
export class AgricolaLoginComponent implements OnInit {

  toastMessage = '';
  toastType: AgricolaToastType = 'error';
  showToast = false;
  isLoading = false;

  constructor(
    private readonly msalService: MsalService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['session_expired']) {
        this.showToastMessage('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.', 'warning');
      }
    });
  }

  showToastMessage(message: string, type: AgricolaToastType = 'error'): void {
    this.toastMessage = message;
    this.toastType = type;
    this.showToast = true;
  }

  hideToast(): void {
    this.showToast = false;
  }

  loginWithMicrosoft(): void {
    this.isLoading = true;

    this.msalService.loginRedirect({
      scopes: ['openid', 'profile', ...environment.apiScopes]
    }).subscribe({
      error: () => {
        this.isLoading = false;
        this.showToastMessage('No se pudo iniciar sesión con Microsoft. Intenta nuevamente.');
      }
    });
  }
}
